// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var CssJs = require("bs-css-emotion/src/CssJs.bs.js");
var React = require("react");
var Atom_Box = require("./Atom_Box.bs.js");
var Belt_Array = require("@rescript/std/lib/js/belt_Array.js");
var Caml_option = require("@rescript/std/lib/js/caml_option.js");
var Particle_Screen_Ds = require("../particle/Particle_Screen_Ds.bs.js");
var Particle_Spacer_Ds = require("../particle/Particle_Spacer_Ds.bs.js");
var Particle_Border_Css = require("../particle/Particle_Border_Css.bs.js");
var Particle_Spacer_Css = require("../particle/Particle_Spacer_Css.bs.js");

var default_blockSpace = Particle_Spacer_Ds.makeNone(undefined);

var $$default = {
  border: /* DividerDefault */8,
  blockSpace: default_blockSpace,
  opacity: 1.0
};

var menuNavigation_blockSpace = Particle_Spacer_Ds.Outside.makeAll("XS");

var menuNavigation = {
  border: /* DividerMenuNavigation */10,
  blockSpace: menuNavigation_blockSpace,
  opacity: 1.0
};

var headerSocialLink_blockSpace = Particle_Spacer_Ds.makeNone(undefined);

var headerSocialLink = {
  border: /* HeaderSocialLink */18,
  blockSpace: headerSocialLink_blockSpace,
  opacity: 1.0
};

var footer_blockSpace = Particle_Spacer_Ds.Outside.makeAll("XS");

var footer = {
  border: /* DividerFooter */9,
  blockSpace: footer_blockSpace,
  opacity: 1.0
};

var corporateMenu_blockSpace = Particle_Spacer_Ds.Outside.makeVerticalAndHorizontal("Zero", "XXS", undefined);

var corporateMenu = {
  border: /* CorporateMenuDivider */6,
  blockSpace: corporateMenu_blockSpace,
  opacity: 1.0
};

var userPanel_blockSpace = Particle_Spacer_Ds.Outside.makeNone(undefined);

var userPanel = {
  border: /* UserPanel */30,
  blockSpace: userPanel_blockSpace,
  opacity: 1.0
};

var mona_blockSpace = Particle_Spacer_Ds.Outside.makeVerticalAndHorizontal("XS", "Zero", undefined);

var mona = {
  border: /* DividerMona */11,
  blockSpace: mona_blockSpace,
  opacity: 1.0
};

var searchGenre_blockSpace = Particle_Spacer_Ds.Outside.make("L", "None", "None", "None", undefined);

var searchGenre = {
  border: /* DividerMenuNavigation */10,
  blockSpace: searchGenre_blockSpace,
  opacity: 1.0
};

var presseGuide_blockSpace = Particle_Spacer_Ds.Outside.makeNone(undefined);

var presseGuide = {
  border: /* PresseGuide */24,
  blockSpace: presseGuide_blockSpace,
  opacity: 0.1
};

function settingsMenu(itemDivider) {
  var color = itemDivider === "Normal" ? "Divider" : "Text";
  return {
          border: {
            TAG: /* SettingsMenu */4,
            _0: color
          },
          blockSpace: Particle_Spacer_Ds.makeNone(undefined),
          opacity: 1.0
        };
}

var player_blockSpace = Particle_Spacer_Ds.makeAll("XS");

var player = {
  border: /* DividerPlayer */12,
  blockSpace: player_blockSpace,
  opacity: 0.1
};

function view(param) {
  return {
          border: param.border,
          blockSpace: param.blockSpace,
          opacity: param.opacity
        };
}

function toCss(dsStyle) {
  var match = view(dsStyle);
  return Belt_Array.concat(Belt_Array.concat([
                  CssJs.padding(CssJs.px(0)),
                  CssJs.opacity(match.opacity)
                ], Particle_Border_Css.toCss(match.border)), Particle_Spacer_Css.toCss(match.blockSpace));
}

function Atom_Divider(Props) {
  var styleOpt = Props.style;
  var display = Props.display;
  var width = Props.width;
  var style = styleOpt !== undefined ? styleOpt : $$default;
  var styleRules = toCss(style);
  var tmp = {
    rules: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, styleRules)
  };
  if (display !== undefined) {
    tmp.display = Caml_option.valFromOption(display);
  }
  if (width !== undefined) {
    tmp.width = Caml_option.valFromOption(width);
  }
  return React.createElement(Atom_Box.make, tmp);
}

var make = Atom_Divider;

exports.menuNavigation = menuNavigation;
exports.footer = footer;
exports.corporateMenu = corporateMenu;
exports.settingsMenu = settingsMenu;
exports.searchGenre = searchGenre;
exports.userPanel = userPanel;
exports.mona = mona;
exports.presseGuide = presseGuide;
exports.headerSocialLink = headerSocialLink;
exports.player = player;
exports.make = make;
/* default Not a pure module */
